<script>
import dateMixin from '@/mixins/dateMixin';
import Repositories from '@/repositories';
const WorkOrdersRepository = Repositories.get('workorders');
import LoadingButton from '@/components/widgets/buttons/loading-button';

export default {
  components: {
    LoadingButton,
  },
  mixins: [dateMixin],
  props: {
    element: Object,
  },
  data() {
    return {
      buttonStatus: 'default',
    };
  },
  methods: {
    manageWorkOrder() {
      this.$router.push({
        name: 'manageWorkOrder',
        params: { idPublic: this.element.idPublic },
      });
    },
    consumeWorkOrder() {
      if (this.element != null && this.element.reservedItemsQuantity > 0) {
        if (this.buttonStatus == 'default' || this.buttonStatus == 'error') {
          this.buttonStatus = 'loading';
          WorkOrdersRepository.actions
            .consume(this.element.idPublic)
            .then(() => {
              this.$emit('work-order-updated', {
                ...this.element,
                consumedItemsQuantity:
                  this.element.consumedItemsQuantity +
                  this.element.reservedItemsQuantity,
                reservedItemsQuantity: this.element.reservedItemsQuantity,
                status:
                  this.element.consumedItemsQuantity +
                    this.element.reservedItemsQuantity ==
                  this.element.consumedItemsQuantity +
                    this.element.totalItemsQuantity
                    ? 'DONE'
                    : this.element.status,
              });
              this.buttonStatus = 'success';
            })
            .catch(() => {
              this.$toast.errorToast(this.$t('errors.errorLoading'));
              this.buttonStatus = 'error';
            });
        }
      }
    },
  },
  computed: {
    leadTimeDays() {
      let timeDifference =
        new Date(this.element.leadTimeDate).getTime() - new Date().getTime();
      let daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
      return this.element.leadTimeDate ? daysDifference : null;
    },
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
  },
};
</script>

<template>
  <b-card
    v-if="element != null"
    style="margin: 5px 5px 0 5px; box-shadow: none"
    no-body
    :class="`${
      element.leadTimeDate && leadTimeDays < 0 ? 'pulse-border' : null
    }`"
  >
    <b-card-body body-class="override-card-body">
      <b-card-title>
        <div class="flex-box">
          <div style="max-width: 180px">
            {{ element.name }}
          </div>
          <div class="flex-push">
            <LoadingButton
              v-if="this.element.reservedItemsQuantity > 0"
              class="ml-2 mr-2"
              :id="'loading-btn-' + element.idPublic"
              size="sm"
              :status="buttonStatus"
              @click="consumeWorkOrder"
              :text="$t('general.consume')"
            />
          </div>

          <div
            style="padding-top: 4px"
            @click.capture.prevent="$emit('open-modal', element)"
          >
            <b-link
              :to="{
                name: 'manageWorkOrder',
                params: { idPublic: element.idPublic },
              }"
            >
              <i class="fas fa-cogs cog-class"></i>
            </b-link>
          </div>
        </div>
        <div class="flex-box mt-4">
          <div :class="`${leadTimeDays < 0 ? 'text-danger' : 'text-success'}`">
            {{ leadTimeDays }}
          </div>
          <div class="flex-push" style="font-weight: 400">
            {{ currencyFormatter.format(element.totalItemsPrice) }}
          </div>
        </div>
      </b-card-title>
    </b-card-body>
    <b-card-body
      body-class="override-card-footer"
      style="border-top: 1px solid #f5f5f5"
    >
      <div class="flex-group-custom">
        <div>
          <li class="list-inline-item">
            <i
              class="far fa-calendar-alt"
              v-b-tooltip.hover
              :title="
                $t('general.deliveryDate') +
                ': ' +
                formatDateShort(element.deliveryDate) +
                '\n' +
                $t('general.installationDate') +
                ': ' +
                formatDateShort(element.installationDate) +
                '\n' +
                $t('general.productionDate') +
                ': ' +
                formatDateShort(element.productionDate)
              "
            ></i>
            {{ formatDateShort(element.deliveryDate) }}
          </li>
        </div>
        <div class="push-custom">
          <li class="list-inline-item">
            <i class="far fa-clipboard"></i>
            {{ element.requestedItemsQuantity }}
          </li>
        </div>
        <div class="flex-element-custom">
          <li class="list-inline-item">
            <i class="fas fa-truck"></i>
            {{ element.orderedItemsQuantity }}
          </li>
        </div>
        <div class="flex-element-custom">
          <li
            class="list-inline-item"
            :style="{
              cursor: element.reservedItemsQuantity > 0 ? 'pointer' : 'default',
            }"
            @click="consumeWorkOrder()"
          >
            <i class="fas fa-boxes"></i>
            {{ element.reservedItemsQuantity }}/{{ element.totalItemsQuantity }}
          </li>
        </div>
        <div class="flex-element-custom">
          <li class="list-inline-item">
            <i class="fas fa-check"></i>
            {{ element.consumedItemsQuantity }}/{{ element.totalItemsQuantity }}
          </li>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<style scoped>
.cog-class {
  color: #595959;
  cursor: pointer;
  font-size: 1.3em;
}

.card-body {
  padding: 1.3em;
}
.flex-group-custom {
  display: flex;
}
.push-custom,
.flex-element-custom {
  margin-left: 15px;
}
.push-custom {
  margin-left: auto;
}

.override-card-body {
  padding: 12px 12px 0 12px;
}

.override-card-footer {
  padding: 12px;
}
@keyframes pulse {
  0% {
    border-left-color: #ffffff;
  }
  50% {
    border-left-color: #ff3737;
  }
  100% {
    border-left-color: #ffffff;
  }
}

.pulse-border {
  border-left: 5px solid; /* Set your desired border color */
  border-left-color: #ff3737;
  animation: pulse 2s infinite;
}
</style>